import AssessmentsByGroups from "./AssessmentsByGroups";

export default AssessmentsByGroups;